import { ADD_TO_BE_DELETED_TAG } from './type'

export const addToBeDeleted = (deleteOrder:number, categories:[]) => {
  return  {
    type: ADD_TO_BE_DELETED_TAG,
    deleteOrder,
    categories
  }
}
